import { CopyButton } from '@/components/copy-button';
import { Button } from '@/components/ui/button';
import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from '@/components/ui/toast';

type Props = {
  apiKey: string;
  toggle: () => void;
};

export const ApiKeyCreateSuccess = ({ apiKey, toggle }: Props) => {
  return (
    <>
      <DialogHeader>
        <DialogTitle className="text-lg font-semibold">API key created</DialogTitle>
        <DialogDescription className="text-sm text-muted-foreground">
          Your API key has been created successfully.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Label htmlFor="generated-private-key" className="text-sm font-medium">
            Your API key
          </Label>
          <div className="flex gap-2">
            <Input
              id="generated-private-key"
              value={apiKey}
              readOnly
              className="h-9 font-mono text-sm"
            />
            <CopyButton
              value={apiKey}
              label="Copy"
              variant="outline"
              size="sm"
              className="h-9 shrink-0"
              resetDelay={2000}
              onCopy={() => toast.success({ title: 'Private API key copied to clipboard' })}
            />
          </div>
        </div>
      </div>
      <DialogFooter>
        <Button onClick={toggle}>Done</Button>
      </DialogFooter>
    </>
  );
};
